// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Section Box - Single container per section */
.section-box {
  background: #ffffff;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 40px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

/* Section Header Override - Keeps the blue line and header styling */
.section-header {
  margin-bottom: 20px;
}

.section-title {
  color: #2c3e50;
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 12px;
  padding-bottom: 12px;
  border-bottom: 3px solid #3498db;
  letter-spacing: 0.5px;
}

/* Form rows */
.form-row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -10px;
  margin-left: -10px;
  margin-bottom: 5px;
}

.form-group {
  padding-right: 10px;
  padding-left: 10px;
  margin-bottom: 18px;
}

  .form-group label {
    font-weight: 600;
    margin-bottom: 5px;
    color: #34495e;
    font-size: 13px;
    display: block;
  }

  .form-group small {
    display: block;
    margin-top: 4px;
    font-size: 11px;
    color: #7f8c8d;
    line-height: 1.3;
  }

/* Form controls */
.form-control {
  height: 36px;
  font-size: 13px;
  border-radius: 4px;
  border: 1px solid #ced4da;
  width: 100%;
}

  .form-control:disabled {
    background-color: #f8f9fa;
    color: #495057;
    cursor: default;
    border-color: #dee2e6;
  }

select.form-control {
  padding-right: 30px;
}

  select.form-control:disabled {
    background-color: #f8f9fa;
    opacity: 1;
  }

textarea.form-control {
  height: auto;
  min-height: 60px;
  resize: vertical;
}

/* Character count */
.char-count {
  display: block;
  text-align: right;
  font-size: 11px;
  color: #7f8c8d;
  margin-top: 3px;
}

/* Header */
.pgTitleWrap {
  border-bottom: 1px solid #dee2e6;
  padding-bottom: 15px;
}

.participant-name {
  font-size: 24px;
  color: #2c3e50;
  font-weight: 700;
  letter-spacing: 0.5px;
}

/* Button styles */
.btn-primary {
  background-color: #3498db;
  border-color: #3498db;
  font-size: 13px;
  padding: 8px 16px;
}

  .btn-primary:hover {
    background-color: #2980b9;
    border-color: #2980b9;
  }

  .btn-primary:disabled {
    background-color: #95a5a6;
    border-color: #95a5a6;
    cursor: not-allowed;
  }

.btn-small {
  padding: 4px 16px;
  font-size: 13px;
  line-height: 1.5;
}

/* Study Number Hyperlink */
::ng-deep .p-datatable a {
  color: #007bff;
  text-decoration: none;
  cursor: pointer;
}

::ng-deep .p-datatable a:hover {
  color: #0056b3;
  text-decoration: underline;
}

.saveChange {
  font-weight: 600;
}

.mr-2 {
  margin-right: 8px;
}

/* Container */
.adminWrap {
  padding: 15px 0;
}

.container-fluid {
  background-color: #f5f7fa;
  min-height: 100vh;
}

/* Column widths */
.col-md-1 {
  flex: 0 0 8.333333%;
  max-width: 8.333333%;
}

.col-md-2 {
  flex: 0 0 16.666667%;
  max-width: 16.666667%;
}

.col-md-3 {
  flex: 0 0 25%;
  max-width: 25%;
}

.col-md-6 {
  flex: 0 0 50%;
  max-width: 50%;
}

/* Required field asterisk */
.required-field {
  color: #e74c3c;
  margin-left: 2px;
}

/* Alert */
.alert-danger {
  background-color: #f8d7da;
  border-color: #f5c6cb;
  color: #721c24;
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 13px;
}

.mb-2 {
  margin-bottom: 8px;
}

/* Text utilities */
.text-danger {
  color: #e74c3c;
}

/* Study Table Styles - Section 2 */
.study-table {
  margin-bottom: 0;
  border-collapse: collapse;
}

  .study-table thead th {
    background-color: #ffffff !important;
    color: #2c3e50;
    font-weight: 700;
    font-size: 14px;
    border-bottom: 3px solid #3498db;
    border-top: none;
    border-left: none;
    border-right: none;
    padding: 12px 10px;
    text-transform: none;
  }

  .study-table tbody td {
    background-color: #ffffff;
    color: #495057;
    font-size: 13px;
    padding: 10px;
    border: 1px solid #e9ecef;
    vertical-align: middle;
  }

  .study-table tbody tr:hover {
    background-color: #f8f9fa;
  }

    .study-table tbody tr:hover td {
      background-color: #f8f9fa;
    }

  /* Remove any first-column grey background */
  .study-table tbody td:first-child,
  .study-table thead th:first-child {
    background-color: #ffffff !important;
  }

  .study-table tbody tr:hover td:first-child {
    background-color: #f8f9fa !important;
  }

.section-divider {
  border: 0;
  border-bottom: 2px solid #333;
  margin: 0 0 15px 0;
}

.section-header {
  -webkit-user-select: none;
          user-select: none;
}

:host ::ng-deep .ui-panel .ui-panel-titlebar,
:host ::ng-deep .p-panel .p-panel-header {
  font-size: 1.5rem !important;
  font-weight: 700 !important;
  color: #2c3e50 !important;
  border-bottom: 3px solid #3498db !important;
  padding-bottom: 8px !important;
  background: transparent !important;
}

:host ::ng-deep .p-panel.section-box {
  margin-bottom: 40px !important;
}

.studyInfo{
  margin-left: -30px !important;
}

/* Responsive */
@media (max-width: 768px) {
  .section-box {
    padding: 15px;
  }

  .form-group {
    margin-bottom: 15px;
  }

  .col-md-1, .col-md-2, .col-md-3, .col-md-6 {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .pgTitleWrap {
    flex-direction: column;
  }

    .pgTitleWrap .col-md-6 {
      margin-bottom: 10px;
    }

  .section-title {
    font-size: 20px;
  }

  .participant-name {
    font-size: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/admin/group-member-details/group-member-details.component.css"],"names":[],"mappings":"AAAA,+CAA+C;AAC/C;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA,qEAAqE;AACrE;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;EAEE;IACE,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;;AAEF,kBAAkB;AAClB;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;AACb;;EAEE;IACE,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,qBAAqB;EACvB;;AAEF;EACE,mBAAmB;AACrB;;EAEE;IACE,yBAAyB;IACzB,UAAU;EACZ;;AAEF;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,iBAAiB;AACnB;;EAEE;IACE,yBAAyB;IACzB,qBAAqB;EACvB;;EAEA;IACE,yBAAyB;IACzB,qBAAqB;IACrB,mBAAmB;EACrB;;AAEF;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,cAAc;AACd;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,cAAc;AAChB;;AAEA,mCAAmC;AACnC;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;EAEE;IACE,oCAAoC;IACpC,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,gCAAgC;IAChC,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,aAAa;IACb,yBAAyB;IACzB,sBAAsB;EACxB;;EAEA;IACE,yBAAyB;EAC3B;;IAEE;MACE,yBAAyB;IAC3B;;EAEF,4CAA4C;EAC5C;;IAEE,oCAAoC;EACtC;;EAEA;IACE,oCAAoC;EACtC;;AAEF;EACE,SAAS;EACT,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;;EAEE,4BAA4B;EAC5B,2BAA2B;EAC3B,yBAAyB;EACzB,2CAA2C;EAC3C,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,eAAe;AACf;EACE;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;IAEE;MACE,mBAAmB;IACrB;;EAEF;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Section Box - Single container per section */\r\n.section-box {\r\n  background: #ffffff;\r\n  border: 1px solid #dee2e6;\r\n  border-radius: 8px;\r\n  padding: 20px;\r\n  margin-bottom: 40px;\r\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n/* Section Header Override - Keeps the blue line and header styling */\r\n.section-header {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.section-title {\r\n  color: #2c3e50;\r\n  font-size: 22px;\r\n  font-weight: 700;\r\n  margin-bottom: 12px;\r\n  padding-bottom: 12px;\r\n  border-bottom: 3px solid #3498db;\r\n  letter-spacing: 0.5px;\r\n}\r\n\r\n/* Form rows */\r\n.form-row {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  margin-right: -10px;\r\n  margin-left: -10px;\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.form-group {\r\n  padding-right: 10px;\r\n  padding-left: 10px;\r\n  margin-bottom: 18px;\r\n}\r\n\r\n  .form-group label {\r\n    font-weight: 600;\r\n    margin-bottom: 5px;\r\n    color: #34495e;\r\n    font-size: 13px;\r\n    display: block;\r\n  }\r\n\r\n  .form-group small {\r\n    display: block;\r\n    margin-top: 4px;\r\n    font-size: 11px;\r\n    color: #7f8c8d;\r\n    line-height: 1.3;\r\n  }\r\n\r\n/* Form controls */\r\n.form-control {\r\n  height: 36px;\r\n  font-size: 13px;\r\n  border-radius: 4px;\r\n  border: 1px solid #ced4da;\r\n  width: 100%;\r\n}\r\n\r\n  .form-control:disabled {\r\n    background-color: #f8f9fa;\r\n    color: #495057;\r\n    cursor: default;\r\n    border-color: #dee2e6;\r\n  }\r\n\r\nselect.form-control {\r\n  padding-right: 30px;\r\n}\r\n\r\n  select.form-control:disabled {\r\n    background-color: #f8f9fa;\r\n    opacity: 1;\r\n  }\r\n\r\ntextarea.form-control {\r\n  height: auto;\r\n  min-height: 60px;\r\n  resize: vertical;\r\n}\r\n\r\n/* Character count */\r\n.char-count {\r\n  display: block;\r\n  text-align: right;\r\n  font-size: 11px;\r\n  color: #7f8c8d;\r\n  margin-top: 3px;\r\n}\r\n\r\n/* Header */\r\n.pgTitleWrap {\r\n  border-bottom: 1px solid #dee2e6;\r\n  padding-bottom: 15px;\r\n}\r\n\r\n.participant-name {\r\n  font-size: 24px;\r\n  color: #2c3e50;\r\n  font-weight: 700;\r\n  letter-spacing: 0.5px;\r\n}\r\n\r\n/* Button styles */\r\n.btn-primary {\r\n  background-color: #3498db;\r\n  border-color: #3498db;\r\n  font-size: 13px;\r\n  padding: 8px 16px;\r\n}\r\n\r\n  .btn-primary:hover {\r\n    background-color: #2980b9;\r\n    border-color: #2980b9;\r\n  }\r\n\r\n  .btn-primary:disabled {\r\n    background-color: #95a5a6;\r\n    border-color: #95a5a6;\r\n    cursor: not-allowed;\r\n  }\r\n\r\n.btn-small {\r\n  padding: 4px 16px;\r\n  font-size: 13px;\r\n  line-height: 1.5;\r\n}\r\n\r\n/* Study Number Hyperlink */\r\n::ng-deep .p-datatable a {\r\n  color: #007bff;\r\n  text-decoration: none;\r\n  cursor: pointer;\r\n}\r\n\r\n::ng-deep .p-datatable a:hover {\r\n  color: #0056b3;\r\n  text-decoration: underline;\r\n}\r\n\r\n.saveChange {\r\n  font-weight: 600;\r\n}\r\n\r\n.mr-2 {\r\n  margin-right: 8px;\r\n}\r\n\r\n/* Container */\r\n.adminWrap {\r\n  padding: 15px 0;\r\n}\r\n\r\n.container-fluid {\r\n  background-color: #f5f7fa;\r\n  min-height: 100vh;\r\n}\r\n\r\n/* Column widths */\r\n.col-md-1 {\r\n  flex: 0 0 8.333333%;\r\n  max-width: 8.333333%;\r\n}\r\n\r\n.col-md-2 {\r\n  flex: 0 0 16.666667%;\r\n  max-width: 16.666667%;\r\n}\r\n\r\n.col-md-3 {\r\n  flex: 0 0 25%;\r\n  max-width: 25%;\r\n}\r\n\r\n.col-md-6 {\r\n  flex: 0 0 50%;\r\n  max-width: 50%;\r\n}\r\n\r\n/* Required field asterisk */\r\n.required-field {\r\n  color: #e74c3c;\r\n  margin-left: 2px;\r\n}\r\n\r\n/* Alert */\r\n.alert-danger {\r\n  background-color: #f8d7da;\r\n  border-color: #f5c6cb;\r\n  color: #721c24;\r\n  padding: 8px 12px;\r\n  border-radius: 4px;\r\n  font-size: 13px;\r\n}\r\n\r\n.mb-2 {\r\n  margin-bottom: 8px;\r\n}\r\n\r\n/* Text utilities */\r\n.text-danger {\r\n  color: #e74c3c;\r\n}\r\n\r\n/* Study Table Styles - Section 2 */\r\n.study-table {\r\n  margin-bottom: 0;\r\n  border-collapse: collapse;\r\n}\r\n\r\n  .study-table thead th {\r\n    background-color: #ffffff !important;\r\n    color: #2c3e50;\r\n    font-weight: 700;\r\n    font-size: 14px;\r\n    border-bottom: 3px solid #3498db;\r\n    border-top: none;\r\n    border-left: none;\r\n    border-right: none;\r\n    padding: 12px 10px;\r\n    text-transform: none;\r\n  }\r\n\r\n  .study-table tbody td {\r\n    background-color: #ffffff;\r\n    color: #495057;\r\n    font-size: 13px;\r\n    padding: 10px;\r\n    border: 1px solid #e9ecef;\r\n    vertical-align: middle;\r\n  }\r\n\r\n  .study-table tbody tr:hover {\r\n    background-color: #f8f9fa;\r\n  }\r\n\r\n    .study-table tbody tr:hover td {\r\n      background-color: #f8f9fa;\r\n    }\r\n\r\n  /* Remove any first-column grey background */\r\n  .study-table tbody td:first-child,\r\n  .study-table thead th:first-child {\r\n    background-color: #ffffff !important;\r\n  }\r\n\r\n  .study-table tbody tr:hover td:first-child {\r\n    background-color: #f8f9fa !important;\r\n  }\r\n\r\n.section-divider {\r\n  border: 0;\r\n  border-bottom: 2px solid #333;\r\n  margin: 0 0 15px 0;\r\n}\r\n\r\n.section-header {\r\n  user-select: none;\r\n}\r\n\r\n:host ::ng-deep .ui-panel .ui-panel-titlebar,\r\n:host ::ng-deep .p-panel .p-panel-header {\r\n  font-size: 1.5rem !important;\r\n  font-weight: 700 !important;\r\n  color: #2c3e50 !important;\r\n  border-bottom: 3px solid #3498db !important;\r\n  padding-bottom: 8px !important;\r\n  background: transparent !important;\r\n}\r\n\r\n:host ::ng-deep .p-panel.section-box {\r\n  margin-bottom: 40px !important;\r\n}\r\n\r\n.studyInfo{\r\n  margin-left: -30px !important;\r\n}\r\n\r\n/* Responsive */\r\n@media (max-width: 768px) {\r\n  .section-box {\r\n    padding: 15px;\r\n  }\r\n\r\n  .form-group {\r\n    margin-bottom: 15px;\r\n  }\r\n\r\n  .col-md-1, .col-md-2, .col-md-3, .col-md-6 {\r\n    flex: 0 0 100%;\r\n    max-width: 100%;\r\n  }\r\n\r\n  .pgTitleWrap {\r\n    flex-direction: column;\r\n  }\r\n\r\n    .pgTitleWrap .col-md-6 {\r\n      margin-bottom: 10px;\r\n    }\r\n\r\n  .section-title {\r\n    font-size: 20px;\r\n  }\r\n\r\n  .participant-name {\r\n    font-size: 20px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
